module.exports = __webpack_public_path__ + "cce1dcb2ce71970144208cf133f4f0c8.svg";